import * as Types from '../../../generated/graphql_types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type NucleusDatasetItemDetailQueryVariables = Types.Exact<{
  datasetItemId: Types.Scalars['ID'];
  modelIds: Types.InputMaybe<ReadonlyArray<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;

export type NucleusDatasetItemDetailQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetItemDetailById: {
    readonly __typename: 'NucleusDatasetItem';
    readonly ref_id: string | null;
    readonly last_edited_at: string | null;
    readonly type: string;
    readonly video_frame: number | null;
    readonly id: string;
    readonly processed_image_url: string | null;
    readonly processed_image_url_grid: string | null;
    readonly processed_image_url_compressed: string | null;
    readonly original_image_url: string;
    readonly processed_video_url: string | null;
    readonly uploaded_asset_id: string | null;
    readonly camera_params: any | null;
    readonly sortMetricText: string | null;
    readonly metadata: ReadonlyArray<{
      readonly __typename?: 'NucleusKeyValuePair';
      readonly key: string;
      readonly value: string | null;
    }> | null;
    readonly autotag_image_items: ReadonlyArray<{
      readonly __typename: 'NucleusAutotagItem';
      readonly autotag_id: string;
      readonly name: string;
      readonly score: number;
    }> | null;
    readonly autotag_object_items: ReadonlyArray<{
      readonly __typename: 'NucleusAutotagItem';
      readonly autotag_id: string;
      readonly name: string;
      readonly score: number;
    }> | null;
    readonly ground_truth_annotations: ReadonlyArray<{
      readonly __typename: 'NucleusGroundTruthAnnotation';
      readonly id: string;
      readonly dataset_item_id: string;
      readonly dataset_id: string;
      readonly task_id: string | null;
      readonly audit_status: Types.AuditReviewStatus | null;
      readonly audit_comment: string | null;
      readonly properties:
        | {
            readonly __typename: 'Nucleus2DBox';
            readonly id: string;
            readonly label: string;
            readonly x: number;
            readonly y: number;
            readonly width: number;
            readonly height: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCategory';
            readonly id: string;
            readonly label: string;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCuboid';
            readonly id: string;
            readonly label: string;
            readonly yaw: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly position: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
            readonly dimensions: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
          }
        | {
            readonly __typename: 'NucleusKeypoints';
            readonly id: string;
            readonly label: string;
            readonly names: ReadonlyArray<string>;
            readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly keypoints: ReadonlyArray<{
              readonly __typename?: 'NucleusKeypoint';
              readonly x: number | null;
              readonly y: number | null;
              readonly visible: boolean | null;
            }>;
          }
        | {
            readonly __typename: 'NucleusLidarSemseg';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusLine';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          }
        | {
            readonly __typename: 'NucleusMultiCategory';
            readonly id: string;
            readonly labels: ReadonlyArray<string>;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusPolygon';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          };
      readonly metadata_schema: {
        readonly __typename?: 'NucleusTable';
        readonly fields: ReadonlyArray<{
          readonly __typename: 'NucleusField';
          readonly id: string;
          readonly name: string;
          readonly params: {
            readonly __typename?: 'NucleusFieldParams';
            readonly choices: ReadonlyArray<string | null> | null;
          } | null;
        }> | null;
      } | null;
      readonly edits: ReadonlyArray<{
        readonly __typename: 'NucleusGroundTruthEdit';
        readonly edit_id: string;
        readonly ground_truth_annotation_id: string;
        readonly created_at: string;
        readonly via: string;
        readonly user_color: string | null;
        readonly user: {
          readonly __typename: 'ScaleUser';
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        };
        readonly annotation:
          | {
              readonly __typename: 'Nucleus2DBox';
              readonly id: string;
              readonly label: string;
              readonly x: number;
              readonly y: number;
              readonly width: number;
              readonly height: number;
              readonly metadata: any | null;
              readonly track_id: string | null;
            }
          | {
              readonly __typename: 'NucleusCategory';
              readonly id: string;
              readonly label: string;
              readonly taxonomy_name: string;
              readonly metadata: any | null;
              readonly track_id: string | null;
            }
          | {
              readonly __typename: 'NucleusCuboid';
              readonly id: string;
              readonly label: string;
              readonly yaw: number;
              readonly metadata: any | null;
              readonly track_id: string | null;
              readonly position: {
                readonly __typename?: 'NucleusXYZ';
                readonly x: number;
                readonly y: number;
                readonly z: number;
              };
              readonly dimensions: {
                readonly __typename?: 'NucleusXYZ';
                readonly x: number;
                readonly y: number;
                readonly z: number;
              };
            }
          | {
              readonly __typename: 'NucleusKeypoints';
              readonly id: string;
              readonly label: string;
              readonly names: ReadonlyArray<string>;
              readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
              readonly metadata: any | null;
              readonly track_id: string | null;
              readonly keypoints: ReadonlyArray<{
                readonly __typename?: 'NucleusKeypoint';
                readonly x: number | null;
                readonly y: number | null;
                readonly visible: boolean | null;
              }>;
            }
          | {
              readonly __typename: 'NucleusLidarSemseg';
              readonly id: string;
              readonly label: string;
              readonly metadata: any | null;
              readonly track_id: string | null;
            }
          | {
              readonly __typename: 'NucleusLine';
              readonly id: string;
              readonly label: string;
              readonly metadata: any | null;
              readonly track_id: string | null;
              readonly vertices: ReadonlyArray<{
                readonly __typename?: 'NucleusXY';
                readonly x: number;
                readonly y: number;
              }>;
            }
          | {
              readonly __typename: 'NucleusMultiCategory';
              readonly id: string;
              readonly labels: ReadonlyArray<string>;
              readonly taxonomy_name: string;
              readonly metadata: any | null;
              readonly track_id: string | null;
            }
          | {
              readonly __typename: 'NucleusPolygon';
              readonly id: string;
              readonly label: string;
              readonly metadata: any | null;
              readonly track_id: string | null;
              readonly vertices: ReadonlyArray<{
                readonly __typename?: 'NucleusXY';
                readonly x: number;
                readonly y: number;
              }>;
            }
          | null;
      }> | null;
    }> | null;
    readonly ground_truth_edits: ReadonlyArray<{
      readonly __typename: 'NucleusGroundTruthEdit';
      readonly edit_id: string;
      readonly ground_truth_annotation_id: string;
      readonly created_at: string;
      readonly edit_type: string;
      readonly via: string;
      readonly user_color: string | null;
      readonly user: {
        readonly __typename: 'ScaleUser';
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
      };
      readonly annotation:
        | {
            readonly __typename: 'Nucleus2DBox';
            readonly id: string;
            readonly label: string;
            readonly x: number;
            readonly y: number;
            readonly width: number;
            readonly height: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCategory';
            readonly id: string;
            readonly label: string;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCuboid';
            readonly id: string;
            readonly label: string;
            readonly yaw: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly position: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
            readonly dimensions: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
          }
        | {
            readonly __typename: 'NucleusKeypoints';
            readonly id: string;
            readonly label: string;
            readonly names: ReadonlyArray<string>;
            readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly keypoints: ReadonlyArray<{
              readonly __typename?: 'NucleusKeypoint';
              readonly x: number | null;
              readonly y: number | null;
              readonly visible: boolean | null;
            }>;
          }
        | {
            readonly __typename: 'NucleusLidarSemseg';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusLine';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          }
        | {
            readonly __typename: 'NucleusMultiCategory';
            readonly id: string;
            readonly labels: ReadonlyArray<string>;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusPolygon';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          }
        | null;
    }> | null;
    readonly predictions: ReadonlyArray<{
      readonly __typename: 'NucleusModelPrediction';
      readonly id: string;
      readonly model_run_id: string;
      readonly confidence: number | null;
      readonly model_run: {
        readonly __typename: 'NucleusModelRun';
        readonly id: string;
        readonly name: string | null;
        readonly started_at: string;
      } | null;
      readonly metadata_schema: {
        readonly __typename?: 'NucleusTable';
        readonly fields: ReadonlyArray<{
          readonly __typename: 'NucleusField';
          readonly id: string;
          readonly name: string;
          readonly params: {
            readonly __typename?: 'NucleusFieldParams';
            readonly choices: ReadonlyArray<string | null> | null;
          } | null;
        }> | null;
      } | null;
      readonly properties:
        | {
            readonly __typename: 'Nucleus2DBox';
            readonly id: string;
            readonly label: string;
            readonly x: number;
            readonly y: number;
            readonly width: number;
            readonly height: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCategory';
            readonly id: string;
            readonly label: string;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCuboid';
            readonly id: string;
            readonly label: string;
            readonly yaw: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly position: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
            readonly dimensions: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
          }
        | {
            readonly __typename: 'NucleusKeypoints';
            readonly id: string;
            readonly label: string;
            readonly names: ReadonlyArray<string>;
            readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly keypoints: ReadonlyArray<{
              readonly __typename?: 'NucleusKeypoint';
              readonly x: number | null;
              readonly y: number | null;
              readonly visible: boolean | null;
            }>;
          }
        | {
            readonly __typename: 'NucleusLidarSemseg';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusLine';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          }
        | {
            readonly __typename: 'NucleusMultiCategory';
            readonly id: string;
            readonly labels: ReadonlyArray<string>;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusPolygon';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          }
        | null;
    }> | null;
    readonly segmentation_predictions: ReadonlyArray<{
      readonly __typename?: 'NucleusSegmentationPrediction';
      readonly model_run_id: string | null;
      readonly mask: {
        readonly __typename: 'NucleusMask';
        readonly id: string;
        readonly colorized_image_url: string;
        readonly indexed_image_url: string;
        readonly original_image_url: string;
        readonly dataset_item_id: string;
      };
      readonly model_run: {
        readonly __typename: 'NucleusModelRun';
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly predictions: ReadonlyArray<{
        readonly __typename: 'NucleusSegment';
        readonly id: string;
        readonly properties: {
          readonly __typename: 'NucleusBaseSegment';
          readonly label: string;
          readonly index: number;
          readonly color: string | null;
          readonly metadata: any | null;
        };
      }>;
    }> | null;
    readonly segmentation: {
      readonly __typename?: 'NucleusSegmentation';
      readonly mask: {
        readonly __typename: 'NucleusMask';
        readonly id: string;
        readonly colorized_image_url: string;
        readonly indexed_image_url: string;
        readonly original_image_url: string;
        readonly dataset_item_id: string;
      };
      readonly annotations: ReadonlyArray<{
        readonly __typename: 'NucleusSegment';
        readonly id: string;
        readonly properties: {
          readonly __typename: 'NucleusBaseSegment';
          readonly label: string;
          readonly index: number;
          readonly color: string | null;
          readonly metadata: any | null;
        };
      }>;
    } | null;
    readonly tasks: ReadonlyArray<{
      readonly __typename?: 'NucleusTask';
      readonly task_id: string;
      readonly subtask_id: string;
      readonly task_status: string;
      readonly task_audit_status: string | null;
      readonly task_audit_review_comment: string | null;
      readonly created_at: string | null;
      readonly completed_at: string | null;
      readonly project_id: string | null;
      readonly project_name: string | null;
      readonly batch_id: string | null;
      readonly batch_name: string | null;
      readonly is_stale: boolean;
      readonly times_redone: number | null;
    }> | null;
    readonly scene: {
      readonly __typename: 'NucleusScene';
      readonly id: string;
      readonly reference_id: string | null;
      readonly frame_count: number | null;
      readonly metadata: ReadonlyArray<{
        readonly __typename?: 'NucleusKeyValuePair';
        readonly key: string;
        readonly value: string | null;
      }> | null;
    } | null;
    readonly grid_transform_params: {
      readonly __typename: 'CameraGridTransformType';
      readonly type: string | null;
      readonly params: {
        readonly __typename?: 'CameraTransformParams';
        readonly matrix: ReadonlyArray<number | null> | null;
      } | null;
    } | null;
    readonly original_image_size: {
      readonly __typename?: 'NucleusImageSize';
      readonly width: number;
      readonly height: number;
    } | null;
  };
};

export type DatasetItemDetailFragment = {
  readonly __typename: 'NucleusDatasetItem';
  readonly ref_id: string | null;
  readonly last_edited_at: string | null;
  readonly type: string;
  readonly video_frame: number | null;
  readonly id: string;
  readonly processed_image_url: string | null;
  readonly processed_image_url_grid: string | null;
  readonly processed_image_url_compressed: string | null;
  readonly original_image_url: string;
  readonly processed_video_url: string | null;
  readonly uploaded_asset_id: string | null;
  readonly camera_params: any | null;
  readonly sortMetricText: string | null;
  readonly metadata: ReadonlyArray<{
    readonly __typename?: 'NucleusKeyValuePair';
    readonly key: string;
    readonly value: string | null;
  }> | null;
  readonly autotag_image_items: ReadonlyArray<{
    readonly __typename: 'NucleusAutotagItem';
    readonly autotag_id: string;
    readonly name: string;
    readonly score: number;
  }> | null;
  readonly autotag_object_items: ReadonlyArray<{
    readonly __typename: 'NucleusAutotagItem';
    readonly autotag_id: string;
    readonly name: string;
    readonly score: number;
  }> | null;
  readonly ground_truth_annotations: ReadonlyArray<{
    readonly __typename: 'NucleusGroundTruthAnnotation';
    readonly id: string;
    readonly dataset_item_id: string;
    readonly dataset_id: string;
    readonly task_id: string | null;
    readonly audit_status: Types.AuditReviewStatus | null;
    readonly audit_comment: string | null;
    readonly properties:
      | {
          readonly __typename: 'Nucleus2DBox';
          readonly id: string;
          readonly label: string;
          readonly x: number;
          readonly y: number;
          readonly width: number;
          readonly height: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCategory';
          readonly id: string;
          readonly label: string;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCuboid';
          readonly id: string;
          readonly label: string;
          readonly yaw: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly position: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
          readonly dimensions: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
        }
      | {
          readonly __typename: 'NucleusKeypoints';
          readonly id: string;
          readonly label: string;
          readonly names: ReadonlyArray<string>;
          readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly keypoints: ReadonlyArray<{
            readonly __typename?: 'NucleusKeypoint';
            readonly x: number | null;
            readonly y: number | null;
            readonly visible: boolean | null;
          }>;
        }
      | {
          readonly __typename: 'NucleusLidarSemseg';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusLine';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        }
      | {
          readonly __typename: 'NucleusMultiCategory';
          readonly id: string;
          readonly labels: ReadonlyArray<string>;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusPolygon';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        };
    readonly metadata_schema: {
      readonly __typename?: 'NucleusTable';
      readonly fields: ReadonlyArray<{
        readonly __typename: 'NucleusField';
        readonly id: string;
        readonly name: string;
        readonly params: {
          readonly __typename?: 'NucleusFieldParams';
          readonly choices: ReadonlyArray<string | null> | null;
        } | null;
      }> | null;
    } | null;
    readonly edits: ReadonlyArray<{
      readonly __typename: 'NucleusGroundTruthEdit';
      readonly edit_id: string;
      readonly ground_truth_annotation_id: string;
      readonly created_at: string;
      readonly via: string;
      readonly user_color: string | null;
      readonly user: {
        readonly __typename: 'ScaleUser';
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
      };
      readonly annotation:
        | {
            readonly __typename: 'Nucleus2DBox';
            readonly id: string;
            readonly label: string;
            readonly x: number;
            readonly y: number;
            readonly width: number;
            readonly height: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCategory';
            readonly id: string;
            readonly label: string;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusCuboid';
            readonly id: string;
            readonly label: string;
            readonly yaw: number;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly position: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
            readonly dimensions: {
              readonly __typename?: 'NucleusXYZ';
              readonly x: number;
              readonly y: number;
              readonly z: number;
            };
          }
        | {
            readonly __typename: 'NucleusKeypoints';
            readonly id: string;
            readonly label: string;
            readonly names: ReadonlyArray<string>;
            readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly keypoints: ReadonlyArray<{
              readonly __typename?: 'NucleusKeypoint';
              readonly x: number | null;
              readonly y: number | null;
              readonly visible: boolean | null;
            }>;
          }
        | {
            readonly __typename: 'NucleusLidarSemseg';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusLine';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          }
        | {
            readonly __typename: 'NucleusMultiCategory';
            readonly id: string;
            readonly labels: ReadonlyArray<string>;
            readonly taxonomy_name: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
          }
        | {
            readonly __typename: 'NucleusPolygon';
            readonly id: string;
            readonly label: string;
            readonly metadata: any | null;
            readonly track_id: string | null;
            readonly vertices: ReadonlyArray<{
              readonly __typename?: 'NucleusXY';
              readonly x: number;
              readonly y: number;
            }>;
          }
        | null;
    }> | null;
  }> | null;
  readonly ground_truth_edits: ReadonlyArray<{
    readonly __typename: 'NucleusGroundTruthEdit';
    readonly edit_id: string;
    readonly ground_truth_annotation_id: string;
    readonly created_at: string;
    readonly edit_type: string;
    readonly via: string;
    readonly user_color: string | null;
    readonly user: {
      readonly __typename: 'ScaleUser';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
    };
    readonly annotation:
      | {
          readonly __typename: 'Nucleus2DBox';
          readonly id: string;
          readonly label: string;
          readonly x: number;
          readonly y: number;
          readonly width: number;
          readonly height: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCategory';
          readonly id: string;
          readonly label: string;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCuboid';
          readonly id: string;
          readonly label: string;
          readonly yaw: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly position: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
          readonly dimensions: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
        }
      | {
          readonly __typename: 'NucleusKeypoints';
          readonly id: string;
          readonly label: string;
          readonly names: ReadonlyArray<string>;
          readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly keypoints: ReadonlyArray<{
            readonly __typename?: 'NucleusKeypoint';
            readonly x: number | null;
            readonly y: number | null;
            readonly visible: boolean | null;
          }>;
        }
      | {
          readonly __typename: 'NucleusLidarSemseg';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusLine';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        }
      | {
          readonly __typename: 'NucleusMultiCategory';
          readonly id: string;
          readonly labels: ReadonlyArray<string>;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusPolygon';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        }
      | null;
  }> | null;
  readonly predictions: ReadonlyArray<{
    readonly __typename: 'NucleusModelPrediction';
    readonly id: string;
    readonly model_run_id: string;
    readonly confidence: number | null;
    readonly model_run: {
      readonly __typename: 'NucleusModelRun';
      readonly id: string;
      readonly name: string | null;
      readonly started_at: string;
    } | null;
    readonly metadata_schema: {
      readonly __typename?: 'NucleusTable';
      readonly fields: ReadonlyArray<{
        readonly __typename: 'NucleusField';
        readonly id: string;
        readonly name: string;
        readonly params: {
          readonly __typename?: 'NucleusFieldParams';
          readonly choices: ReadonlyArray<string | null> | null;
        } | null;
      }> | null;
    } | null;
    readonly properties:
      | {
          readonly __typename: 'Nucleus2DBox';
          readonly id: string;
          readonly label: string;
          readonly x: number;
          readonly y: number;
          readonly width: number;
          readonly height: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCategory';
          readonly id: string;
          readonly label: string;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCuboid';
          readonly id: string;
          readonly label: string;
          readonly yaw: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly position: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
          readonly dimensions: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
        }
      | {
          readonly __typename: 'NucleusKeypoints';
          readonly id: string;
          readonly label: string;
          readonly names: ReadonlyArray<string>;
          readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly keypoints: ReadonlyArray<{
            readonly __typename?: 'NucleusKeypoint';
            readonly x: number | null;
            readonly y: number | null;
            readonly visible: boolean | null;
          }>;
        }
      | {
          readonly __typename: 'NucleusLidarSemseg';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusLine';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        }
      | {
          readonly __typename: 'NucleusMultiCategory';
          readonly id: string;
          readonly labels: ReadonlyArray<string>;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusPolygon';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        }
      | null;
  }> | null;
  readonly segmentation_predictions: ReadonlyArray<{
    readonly __typename?: 'NucleusSegmentationPrediction';
    readonly model_run_id: string | null;
    readonly mask: {
      readonly __typename: 'NucleusMask';
      readonly id: string;
      readonly colorized_image_url: string;
      readonly indexed_image_url: string;
      readonly original_image_url: string;
      readonly dataset_item_id: string;
    };
    readonly model_run: {
      readonly __typename: 'NucleusModelRun';
      readonly id: string;
      readonly name: string | null;
    } | null;
    readonly predictions: ReadonlyArray<{
      readonly __typename: 'NucleusSegment';
      readonly id: string;
      readonly properties: {
        readonly __typename: 'NucleusBaseSegment';
        readonly label: string;
        readonly index: number;
        readonly color: string | null;
        readonly metadata: any | null;
      };
    }>;
  }> | null;
  readonly segmentation: {
    readonly __typename?: 'NucleusSegmentation';
    readonly mask: {
      readonly __typename: 'NucleusMask';
      readonly id: string;
      readonly colorized_image_url: string;
      readonly indexed_image_url: string;
      readonly original_image_url: string;
      readonly dataset_item_id: string;
    };
    readonly annotations: ReadonlyArray<{
      readonly __typename: 'NucleusSegment';
      readonly id: string;
      readonly properties: {
        readonly __typename: 'NucleusBaseSegment';
        readonly label: string;
        readonly index: number;
        readonly color: string | null;
        readonly metadata: any | null;
      };
    }>;
  } | null;
  readonly tasks: ReadonlyArray<{
    readonly __typename?: 'NucleusTask';
    readonly task_id: string;
    readonly subtask_id: string;
    readonly task_status: string;
    readonly task_audit_status: string | null;
    readonly task_audit_review_comment: string | null;
    readonly created_at: string | null;
    readonly completed_at: string | null;
    readonly project_id: string | null;
    readonly project_name: string | null;
    readonly batch_id: string | null;
    readonly batch_name: string | null;
    readonly is_stale: boolean;
    readonly times_redone: number | null;
  }> | null;
  readonly scene: {
    readonly __typename: 'NucleusScene';
    readonly id: string;
    readonly reference_id: string | null;
    readonly frame_count: number | null;
    readonly metadata: ReadonlyArray<{
      readonly __typename?: 'NucleusKeyValuePair';
      readonly key: string;
      readonly value: string | null;
    }> | null;
  } | null;
  readonly grid_transform_params: {
    readonly __typename: 'CameraGridTransformType';
    readonly type: string | null;
    readonly params: {
      readonly __typename?: 'CameraTransformParams';
      readonly matrix: ReadonlyArray<number | null> | null;
    } | null;
  } | null;
  readonly original_image_size: {
    readonly __typename?: 'NucleusImageSize';
    readonly width: number;
    readonly height: number;
  } | null;
};

export type TaskFragment = {
  readonly __typename?: 'NucleusTask';
  readonly task_id: string;
  readonly subtask_id: string;
  readonly task_status: string;
  readonly task_audit_status: string | null;
  readonly task_audit_review_comment: string | null;
  readonly created_at: string | null;
  readonly completed_at: string | null;
  readonly project_id: string | null;
  readonly project_name: string | null;
  readonly batch_id: string | null;
  readonly batch_name: string | null;
  readonly is_stale: boolean;
  readonly times_redone: number | null;
};

export type SegmentationFragment = {
  readonly __typename?: 'NucleusSegmentation';
  readonly mask: {
    readonly __typename: 'NucleusMask';
    readonly id: string;
    readonly colorized_image_url: string;
    readonly indexed_image_url: string;
    readonly original_image_url: string;
    readonly dataset_item_id: string;
  };
  readonly annotations: ReadonlyArray<{
    readonly __typename: 'NucleusSegment';
    readonly id: string;
    readonly properties: {
      readonly __typename: 'NucleusBaseSegment';
      readonly label: string;
      readonly index: number;
      readonly color: string | null;
      readonly metadata: any | null;
    };
  }>;
};

export type SegmentationPredictionFragment = {
  readonly __typename?: 'NucleusSegmentationPrediction';
  readonly model_run_id: string | null;
  readonly mask: {
    readonly __typename: 'NucleusMask';
    readonly id: string;
    readonly colorized_image_url: string;
    readonly indexed_image_url: string;
    readonly original_image_url: string;
    readonly dataset_item_id: string;
  };
  readonly model_run: {
    readonly __typename: 'NucleusModelRun';
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly predictions: ReadonlyArray<{
    readonly __typename: 'NucleusSegment';
    readonly id: string;
    readonly properties: {
      readonly __typename: 'NucleusBaseSegment';
      readonly label: string;
      readonly index: number;
      readonly color: string | null;
      readonly metadata: any | null;
    };
  }>;
};

export type AnnotationProps_Nucleus2DBox_Fragment = {
  readonly __typename: 'Nucleus2DBox';
  readonly id: string;
  readonly label: string;
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly metadata: any | null;
  readonly track_id: string | null;
};

export type AnnotationProps_NucleusCategory_Fragment = {
  readonly __typename: 'NucleusCategory';
  readonly id: string;
  readonly label: string;
  readonly taxonomy_name: string;
  readonly metadata: any | null;
  readonly track_id: string | null;
};

export type AnnotationProps_NucleusCuboid_Fragment = {
  readonly __typename: 'NucleusCuboid';
  readonly id: string;
  readonly label: string;
  readonly yaw: number;
  readonly metadata: any | null;
  readonly track_id: string | null;
  readonly position: {
    readonly __typename?: 'NucleusXYZ';
    readonly x: number;
    readonly y: number;
    readonly z: number;
  };
  readonly dimensions: {
    readonly __typename?: 'NucleusXYZ';
    readonly x: number;
    readonly y: number;
    readonly z: number;
  };
};

export type AnnotationProps_NucleusKeypoints_Fragment = {
  readonly __typename: 'NucleusKeypoints';
  readonly id: string;
  readonly label: string;
  readonly names: ReadonlyArray<string>;
  readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
  readonly metadata: any | null;
  readonly track_id: string | null;
  readonly keypoints: ReadonlyArray<{
    readonly __typename?: 'NucleusKeypoint';
    readonly x: number | null;
    readonly y: number | null;
    readonly visible: boolean | null;
  }>;
};

export type AnnotationProps_NucleusLidarSemseg_Fragment = {
  readonly __typename: 'NucleusLidarSemseg';
  readonly id: string;
  readonly label: string;
  readonly metadata: any | null;
  readonly track_id: string | null;
};

export type AnnotationProps_NucleusLine_Fragment = {
  readonly __typename: 'NucleusLine';
  readonly id: string;
  readonly label: string;
  readonly metadata: any | null;
  readonly track_id: string | null;
  readonly vertices: ReadonlyArray<{
    readonly __typename?: 'NucleusXY';
    readonly x: number;
    readonly y: number;
  }>;
};

export type AnnotationProps_NucleusMultiCategory_Fragment = {
  readonly __typename: 'NucleusMultiCategory';
  readonly id: string;
  readonly labels: ReadonlyArray<string>;
  readonly taxonomy_name: string;
  readonly metadata: any | null;
  readonly track_id: string | null;
};

export type AnnotationProps_NucleusPolygon_Fragment = {
  readonly __typename: 'NucleusPolygon';
  readonly id: string;
  readonly label: string;
  readonly metadata: any | null;
  readonly track_id: string | null;
  readonly vertices: ReadonlyArray<{
    readonly __typename?: 'NucleusXY';
    readonly x: number;
    readonly y: number;
  }>;
};

export type AnnotationPropsFragment =
  | AnnotationProps_Nucleus2DBox_Fragment
  | AnnotationProps_NucleusCategory_Fragment
  | AnnotationProps_NucleusCuboid_Fragment
  | AnnotationProps_NucleusKeypoints_Fragment
  | AnnotationProps_NucleusLidarSemseg_Fragment
  | AnnotationProps_NucleusLine_Fragment
  | AnnotationProps_NucleusMultiCategory_Fragment
  | AnnotationProps_NucleusPolygon_Fragment;

export type DatasetItemFragment = {
  readonly __typename: 'NucleusDatasetItem';
  readonly id: string;
  readonly processed_image_url: string | null;
  readonly processed_image_url_grid: string | null;
  readonly processed_image_url_compressed: string | null;
  readonly original_image_url: string;
  readonly processed_video_url: string | null;
  readonly uploaded_asset_id: string | null;
  readonly camera_params: any | null;
  readonly sortMetricText: string | null;
  readonly type: string;
  readonly ref_id: string | null;
  readonly grid_transform_params: {
    readonly __typename: 'CameraGridTransformType';
    readonly type: string | null;
    readonly params: {
      readonly __typename?: 'CameraTransformParams';
      readonly matrix: ReadonlyArray<number | null> | null;
    } | null;
  } | null;
  readonly metadata: ReadonlyArray<{
    readonly __typename?: 'NucleusKeyValuePair';
    readonly key: string;
    readonly value: string | null;
  }> | null;
  readonly original_image_size: {
    readonly __typename?: 'NucleusImageSize';
    readonly width: number;
    readonly height: number;
  } | null;
};

export type SegmentationMaskFragment = {
  readonly __typename: 'NucleusMask';
  readonly id: string;
  readonly colorized_image_url: string;
  readonly indexed_image_url: string;
  readonly original_image_url: string;
  readonly dataset_item_id: string;
};

export type SegmentFragment = {
  readonly __typename: 'NucleusSegment';
  readonly id: string;
  readonly properties: {
    readonly __typename: 'NucleusBaseSegment';
    readonly label: string;
    readonly index: number;
    readonly color: string | null;
    readonly metadata: any | null;
  };
};

export type AnnotationInfoFragment = {
  readonly __typename: 'NucleusGroundTruthAnnotation';
  readonly id: string;
  readonly dataset_item_id: string;
  readonly dataset_id: string;
  readonly task_id: string | null;
  readonly audit_status: Types.AuditReviewStatus | null;
  readonly audit_comment: string | null;
  readonly properties:
    | {
        readonly __typename: 'Nucleus2DBox';
        readonly id: string;
        readonly label: string;
        readonly x: number;
        readonly y: number;
        readonly width: number;
        readonly height: number;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusCategory';
        readonly id: string;
        readonly label: string;
        readonly taxonomy_name: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusCuboid';
        readonly id: string;
        readonly label: string;
        readonly yaw: number;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly position: {
          readonly __typename?: 'NucleusXYZ';
          readonly x: number;
          readonly y: number;
          readonly z: number;
        };
        readonly dimensions: {
          readonly __typename?: 'NucleusXYZ';
          readonly x: number;
          readonly y: number;
          readonly z: number;
        };
      }
    | {
        readonly __typename: 'NucleusKeypoints';
        readonly id: string;
        readonly label: string;
        readonly names: ReadonlyArray<string>;
        readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly keypoints: ReadonlyArray<{
          readonly __typename?: 'NucleusKeypoint';
          readonly x: number | null;
          readonly y: number | null;
          readonly visible: boolean | null;
        }>;
      }
    | {
        readonly __typename: 'NucleusLidarSemseg';
        readonly id: string;
        readonly label: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusLine';
        readonly id: string;
        readonly label: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly vertices: ReadonlyArray<{
          readonly __typename?: 'NucleusXY';
          readonly x: number;
          readonly y: number;
        }>;
      }
    | {
        readonly __typename: 'NucleusMultiCategory';
        readonly id: string;
        readonly labels: ReadonlyArray<string>;
        readonly taxonomy_name: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusPolygon';
        readonly id: string;
        readonly label: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly vertices: ReadonlyArray<{
          readonly __typename?: 'NucleusXY';
          readonly x: number;
          readonly y: number;
        }>;
      };
  readonly metadata_schema: {
    readonly __typename?: 'NucleusTable';
    readonly fields: ReadonlyArray<{
      readonly __typename: 'NucleusField';
      readonly id: string;
      readonly name: string;
      readonly params: {
        readonly __typename?: 'NucleusFieldParams';
        readonly choices: ReadonlyArray<string | null> | null;
      } | null;
    }> | null;
  } | null;
  readonly edits: ReadonlyArray<{
    readonly __typename: 'NucleusGroundTruthEdit';
    readonly edit_id: string;
    readonly ground_truth_annotation_id: string;
    readonly created_at: string;
    readonly via: string;
    readonly user_color: string | null;
    readonly user: {
      readonly __typename: 'ScaleUser';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
    };
    readonly annotation:
      | {
          readonly __typename: 'Nucleus2DBox';
          readonly id: string;
          readonly label: string;
          readonly x: number;
          readonly y: number;
          readonly width: number;
          readonly height: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCategory';
          readonly id: string;
          readonly label: string;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusCuboid';
          readonly id: string;
          readonly label: string;
          readonly yaw: number;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly position: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
          readonly dimensions: {
            readonly __typename?: 'NucleusXYZ';
            readonly x: number;
            readonly y: number;
            readonly z: number;
          };
        }
      | {
          readonly __typename: 'NucleusKeypoints';
          readonly id: string;
          readonly label: string;
          readonly names: ReadonlyArray<string>;
          readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly keypoints: ReadonlyArray<{
            readonly __typename?: 'NucleusKeypoint';
            readonly x: number | null;
            readonly y: number | null;
            readonly visible: boolean | null;
          }>;
        }
      | {
          readonly __typename: 'NucleusLidarSemseg';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusLine';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        }
      | {
          readonly __typename: 'NucleusMultiCategory';
          readonly id: string;
          readonly labels: ReadonlyArray<string>;
          readonly taxonomy_name: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
        }
      | {
          readonly __typename: 'NucleusPolygon';
          readonly id: string;
          readonly label: string;
          readonly metadata: any | null;
          readonly track_id: string | null;
          readonly vertices: ReadonlyArray<{
            readonly __typename?: 'NucleusXY';
            readonly x: number;
            readonly y: number;
          }>;
        }
      | null;
  }> | null;
};

export type PredictionFragment = {
  readonly __typename: 'NucleusModelPrediction';
  readonly id: string;
  readonly model_run_id: string;
  readonly confidence: number | null;
  readonly properties:
    | {
        readonly __typename: 'Nucleus2DBox';
        readonly id: string;
        readonly label: string;
        readonly x: number;
        readonly y: number;
        readonly width: number;
        readonly height: number;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusCategory';
        readonly id: string;
        readonly label: string;
        readonly taxonomy_name: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusCuboid';
        readonly id: string;
        readonly label: string;
        readonly yaw: number;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly position: {
          readonly __typename?: 'NucleusXYZ';
          readonly x: number;
          readonly y: number;
          readonly z: number;
        };
        readonly dimensions: {
          readonly __typename?: 'NucleusXYZ';
          readonly x: number;
          readonly y: number;
          readonly z: number;
        };
      }
    | {
        readonly __typename: 'NucleusKeypoints';
        readonly id: string;
        readonly label: string;
        readonly names: ReadonlyArray<string>;
        readonly skeleton: ReadonlyArray<ReadonlyArray<number>> | null;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly keypoints: ReadonlyArray<{
          readonly __typename?: 'NucleusKeypoint';
          readonly x: number | null;
          readonly y: number | null;
          readonly visible: boolean | null;
        }>;
      }
    | {
        readonly __typename: 'NucleusLidarSemseg';
        readonly id: string;
        readonly label: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusLine';
        readonly id: string;
        readonly label: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly vertices: ReadonlyArray<{
          readonly __typename?: 'NucleusXY';
          readonly x: number;
          readonly y: number;
        }>;
      }
    | {
        readonly __typename: 'NucleusMultiCategory';
        readonly id: string;
        readonly labels: ReadonlyArray<string>;
        readonly taxonomy_name: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
      }
    | {
        readonly __typename: 'NucleusPolygon';
        readonly id: string;
        readonly label: string;
        readonly metadata: any | null;
        readonly track_id: string | null;
        readonly vertices: ReadonlyArray<{
          readonly __typename?: 'NucleusXY';
          readonly x: number;
          readonly y: number;
        }>;
      }
    | null;
};

export type TransformParamsFragment = {
  readonly __typename: 'CameraGridTransformType';
  readonly type: string | null;
  readonly params: {
    readonly __typename?: 'CameraTransformParams';
    readonly matrix: ReadonlyArray<number | null> | null;
  } | null;
};

export type AutotagItemFragment = {
  readonly __typename: 'NucleusAutotagItem';
  readonly autotag_id: string;
  readonly name: string;
  readonly score: number;
};

export const TransformParamsFragmentDoc = gql`
  fragment transformParams on NucleusGridTransformParamsUnion {
    ... on CameraGridTransformType {
      __typename
      type
      params {
        matrix
      }
    }
  }
`;
export const DatasetItemFragmentDoc = gql`
  fragment datasetItem on NucleusDatasetItem {
    __typename
    id
    processed_image_url
    processed_image_url_grid
    processed_image_url_compressed
    original_image_url
    processed_video_url
    uploaded_asset_id
    grid_transform_params {
      ...transformParams
    }
    camera_params
    sortMetricText
    type
    ref_id
    metadata {
      key
      value
    }
    original_image_size {
      width
      height
    }
  }
  ${TransformParamsFragmentDoc}
`;
export const AutotagItemFragmentDoc = gql`
  fragment autotagItem on NucleusAutotagItem {
    __typename
    autotag_id
    name
    score
  }
`;
export const AnnotationPropsFragmentDoc = gql`
  fragment annotationProps on NucleusBaseAnnotationUnion {
    ... on Nucleus2DBox {
      __typename
      id
      label
      x
      y
      width
      height
      metadata
      track_id
    }
    ... on NucleusPolygon {
      __typename
      id
      label
      vertices {
        x
        y
      }
      metadata
      track_id
    }
    ... on NucleusLine {
      __typename
      id
      label
      vertices {
        x
        y
      }
      metadata
      track_id
    }
    ... on NucleusCuboid {
      __typename
      id
      label
      position {
        x
        y
        z
      }
      dimensions {
        x
        y
        z
      }
      yaw
      metadata
      track_id
    }
    ... on NucleusCategory {
      __typename
      id
      label
      taxonomy_name
      metadata
      track_id
    }
    ... on NucleusMultiCategory {
      __typename
      id
      labels
      taxonomy_name
      metadata
      track_id
    }
    ... on NucleusKeypoints {
      __typename
      id
      label
      keypoints {
        x
        y
        visible
      }
      names
      skeleton
      metadata
      track_id
    }
    ... on NucleusLidarSemseg {
      __typename
      id
      label
      metadata
      track_id
    }
  }
`;
export const AnnotationInfoFragmentDoc = gql`
  fragment annotationInfo on NucleusGroundTruthAnnotation {
    __typename
    id
    dataset_item_id
    dataset_id
    task_id
    audit_status
    audit_comment
    properties {
      ...annotationProps
    }
    metadata_schema {
      fields {
        __typename
        id
        name
        params {
          choices
        }
      }
    }
    edits {
      __typename
      edit_id
      ground_truth_annotation_id
      created_at
      via
      user {
        __typename
        id
        firstName
        lastName
      }
      user_color
      annotation {
        ...annotationProps
      }
    }
  }
  ${AnnotationPropsFragmentDoc}
`;
export const PredictionFragmentDoc = gql`
  fragment prediction on NucleusModelPrediction {
    __typename
    id
    model_run_id
    confidence
    properties {
      ...annotationProps
    }
  }
  ${AnnotationPropsFragmentDoc}
`;
export const SegmentationMaskFragmentDoc = gql`
  fragment segmentationMask on NucleusMask {
    __typename
    id
    colorized_image_url
    indexed_image_url
    original_image_url
    dataset_item_id
  }
`;
export const SegmentFragmentDoc = gql`
  fragment segment on NucleusSegment {
    __typename
    id
    properties {
      __typename
      label
      index
      color
      metadata
    }
  }
`;
export const SegmentationPredictionFragmentDoc = gql`
  fragment segmentationPrediction on NucleusSegmentationPrediction {
    model_run_id
    mask {
      ...segmentationMask
    }
    model_run {
      __typename
      id
      name
    }
    predictions {
      ...segment
    }
  }
  ${SegmentationMaskFragmentDoc}
  ${SegmentFragmentDoc}
`;
export const SegmentationFragmentDoc = gql`
  fragment segmentation on NucleusSegmentation {
    mask {
      ...segmentationMask
    }
    annotations {
      ...segment
    }
  }
  ${SegmentationMaskFragmentDoc}
  ${SegmentFragmentDoc}
`;
export const TaskFragmentDoc = gql`
  fragment task on NucleusTask {
    task_id
    subtask_id
    task_status
    task_audit_status
    task_audit_review_comment
    created_at
    completed_at
    project_id
    project_name
    batch_id
    batch_name
    is_stale
    times_redone
  }
`;
export const DatasetItemDetailFragmentDoc = gql`
  fragment datasetItemDetail on NucleusDatasetItem {
    ...datasetItem
    ref_id
    last_edited_at
    metadata {
      key
      value
    }
    autotag_image_items {
      ...autotagItem
    }
    autotag_object_items {
      ...autotagItem
    }
    ground_truth_annotations {
      ...annotationInfo
    }
    ground_truth_edits {
      __typename
      edit_id
      ground_truth_annotation_id
      created_at
      edit_type
      via
      user {
        __typename
        id
        firstName
        lastName
      }
      user_color
      annotation {
        ...annotationProps
      }
    }
    predictions(modelIds: $modelIds) {
      ...prediction
      model_run {
        __typename
        id
        name
        started_at
      }
      metadata_schema {
        fields {
          __typename
          id
          name
          params {
            choices
          }
        }
      }
    }
    segmentation_predictions(modelIds: $modelIds) {
      ...segmentationPrediction
    }
    segmentation {
      ...segmentation
    }
    tasks {
      ...task
    }
    scene {
      __typename
      id
      reference_id
      frame_count
      metadata {
        key
        value
      }
    }
    type
    video_frame
  }
  ${DatasetItemFragmentDoc}
  ${AutotagItemFragmentDoc}
  ${AnnotationInfoFragmentDoc}
  ${AnnotationPropsFragmentDoc}
  ${PredictionFragmentDoc}
  ${SegmentationPredictionFragmentDoc}
  ${SegmentationFragmentDoc}
  ${TaskFragmentDoc}
`;
export const NucleusDatasetItemDetailDocument = gql`
  query NucleusDatasetItemDetail($datasetItemId: ID!, $modelIds: [ID!]) {
    nucleusDatasetItemDetailById(id: $datasetItemId) {
      ...datasetItemDetail
    }
  }
  ${DatasetItemDetailFragmentDoc}
`;

export function useNucleusDatasetItemDetailQuery(
  options: Omit<Urql.UseQueryArgs<NucleusDatasetItemDetailQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetItemDetailQuery, NucleusDatasetItemDetailQueryVariables>({
    query: NucleusDatasetItemDetailDocument,
    ...options,
  });
}
